import {
  Button,
  CommentLanguageIcon,
  PopoverBody,
  PopoverFooter,
  PopoverHeader,
  Typography,
} from '@execonline-inc/execonline-ui';
import { AlreadyTranslated } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import { ExperienceDictionaryEntryResponse } from '../../../../../ExperiencesDictionary/Types';
import Competencies from './Competencies';
import ProgramDates from './ProgramDates';
import TimeCommitment from './TimeCommitment';
import { getLanguageEnglishNames } from '../../../../../../SupportedLanguages/Types';

interface Props {
  experience: ExperienceDictionaryEntryResponse;
}

function ExperiencePopover({ experience }: Props) {
  return (
    <>
      <PopoverHeader className="flex flex-col gap-y-3">
        <Typography className="text-blue-600" variant="bodySmall" fontWeight="medium">
          Alert Message (if any)
        </Typography>
        <Typography
          className="cursor-pointer text-gray-800"
          tabIndex={0}
          variant="subtitleMedium"
          as="h5"
          fontWeight="medium"
        >
          <AlreadyTranslated content={experience.payload.title} />
        </Typography>
      </PopoverHeader>
      <PopoverBody className="-ml-2 max-h-[26.25rem] gap-y-4 pb-1 pl-2">
        <TimeCommitment experience={experience} />
        <div className="flex items-center gap-x-2">
          <CommentLanguageIcon size="md" />
          <Typography variant="caption">
            <T
              kind="Available in <span>{{languages}}</span>"
              languages={getLanguageEnglishNames(experience.payload.supportedLanguageCodes).join(
                ', ',
              )}
              span={(languages) => <>{languages}</>}
            />
          </Typography>
        </div>
        <Typography variant="caption" className="whitespace-pre-line">
          <AlreadyTranslated content={experience.payload.description} />
        </Typography>
        <Competencies experience={experience} />
        <ProgramDates />
      </PopoverBody>
      <PopoverFooter className="gap-y-2 empty:hidden">
        <Button
          color="gray"
          fullWidth
          data-intercom-target="discovery-portal-popover-enroll-button"
        >
          <T kind="Enroll" />
        </Button>
      </PopoverFooter>
    </>
  );
}

export default observer(ExperiencePopover);
